﻿import { debounce } from '@fe/core';
import { ProductsChangedEventTypes, SelectedWeatherItem } from '@fe/weather';
import React from 'react';
import { WorkspaceManagementContext } from '../../../app/contexts/workspace/workspace-management-context';

export default function useAllWorkspacesSelectedWeather(options?: { ignoreEvents?: ProductsChangedEventTypes[] }) {
    const managementContext = React.useContext(WorkspaceManagementContext);

    const getAllProducts = React.useCallback(() => {
        const seen = new Set<number>();
        const combined: SelectedWeatherItem[] = [];
        for (const item of managementContext.items) {
            if (!item?.weatherService) { continue; }
            for (const product of item.weatherService.getSelectedProducts()) {
                if (!seen.has(product.id)) {
                    seen.add(product.id);
                    combined.push(product);
                }
            }
        }
        return combined;
    }, [managementContext.items]);

    const [selectedProducts, setSelectedProducts] = React.useState<SelectedWeatherItem[]>(() => getAllProducts());

    const debouncedUpdate = React.useCallback(debounce<[SelectedWeatherItem[]]>(setSelectedProducts, 25), []);

    React.useEffect(() => {
        setSelectedProducts(getAllProducts());

        const unsubscribes = managementContext.items
            .filter((item) => item?.weatherService)
            .map((item) =>
                item.weatherService.on('products.changed', (e) => {
                    if (options?.ignoreEvents?.includes(e.kind)) {
                        return;
                    }
                    debouncedUpdate(getAllProducts());
                }).unsubscribe
            );

        return () => unsubscribes.forEach((u) => u());
    }, [managementContext.items, getAllProducts, debouncedUpdate, ...(options?.ignoreEvents ?? [])]);

    return selectedProducts;
}


